// @flow
import { decorate, observable, action } from 'mobx';

import Api from '../../api';

class MigrationStore {
  showMaintenancePage = false;

  isFetching = false;

  fetchMigrationStatus = async () => {
    this.isFetching = true;
    try {
      const { data } = await Api.getMigrationStatus();
      this.showMaintenancePage = data?.showMaintenancePage ?? false;
    } catch (e) {
      this.showMaintenancePage = false;
    } finally {
      this.isFetching = false;
    }
  };
}

decorate(MigrationStore, {
  showMaintenancePage: observable,
  isFetching: observable,
  fetchMigrationStatus: action,
});

export default new MigrationStore();
